export const API = {
  // endpoint: window.location.hostname === "localhost" ? "https://259s7s89-5004.inc1.devtunnels.ms/api/v1/" : "https://259s7s89-5004.inc1.devtunnels.ms/api/v1/",
  endpoint: window.location.hostname === "localhost" ? "https://api.voico.rejoicehub.com/api/v1/" : "https://api.voico.rejoicehub.com/api/v1/",
};
